import { merge } from 'lodash';
import { uid } from '@fiverr-private/futile/lib/random';
import { globalEventBus } from '@fiverr-private/futile/lib/event/globalEventBus';
import { store } from '../Previewer/store';
import { getCurrentGroup } from '../Previewer/selectors/groups';
import * as SettingsSelectors from '../Previewer/selectors/settings';
import { getCurrentFilerrId, getCurrentGroupId } from '../Previewer/selectors/current';

const listeners = {};
const LAZY_QUEUE_TIMEOUT_IN_SECONDS = 10;
const LAZY_QUEUE_DEFAULT_INTERVAL_IN_SECONDS = 0.5;

// Report to BigQuery with payload enrichment from the redux store!
function reportToBigQuery(eventData) {
    try {
        executeLazyQueue({
            interval: (cachedState, recentState) => {
                const isCollaborationEnabled = SettingsSelectors.isCollaborationAsked(cachedState);
                const currentCollaborationGroupId = getCurrentGroupId(recentState);

                if (isCollaborationEnabled && !currentCollaborationGroupId) {
                    return true;
                }

                return false;
            },
            eventData,
            eventUid: uid()
        }, LAZY_QUEUE_TIMEOUT_IN_SECONDS);
    } catch (e) {
        //
    }
}

function executeLazyQueue(event, timeout, cachedState = store.getState()) {
    const { eventUid, eventData, interval } = event;
    clearInterval(listeners[eventUid]);
    if (interval(cachedState, store.getState()) && timeout > 0) {
        listeners[eventUid] = setInterval(() => {
            executeLazyQueue(event, timeout - LAZY_QUEUE_DEFAULT_INTERVAL_IN_SECONDS, cachedState);
        }, LAZY_QUEUE_DEFAULT_INTERVAL_IN_SECONDS * 1000);
    } else {
        const state = store.getState();
        const cachedFileId = getCurrentFilerrId(state);
        const isCollaborationEnabled = SettingsSelectors.isCollaborationAsked(state);
        const currentCollaborationGroup = getCurrentGroup(state);
        const source = SettingsSelectors.getSource(state);

        const enrichment = {
            attachment: {
                id: cachedFileId,
                preview: {
                    viewer_type: isCollaborationEnabled ? 'collaboration' : 'regular'
                }
            }
        };

        const collaborationSource = {
            collaboration: {
                source
            }
        };

        if (!eventData.collaboration && currentCollaborationGroup) {
            enrichment.collaboration = {
                group: {
                    id: currentCollaborationGroup.id,
                    type: currentCollaborationGroup.type
                }
            };
        }
        const enrichedEventData = merge(collaborationSource, enrichment, eventData);
        globalEventBus.emit('attachments-preview:report', enrichedEventData);
    }
}

export default reportToBigQuery;
